
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/more-time",
      function () {
        return require("private-next-pages/more-time.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/more-time"])
      });
    }
  